import { periodToRange } from '../../../../../../domain';
import { getReportName } from '../../../../../app';
import { ValueFormatter } from '../../../../../app/attributes';
import { ReportDetailAggregate } from '../reportDetailModel';
import { ReportDetailRootProps } from './reportRootProps';

export function buildReportRootProps(
    formatter: ValueFormatter,
    item: ReportDetailAggregate
): ReportDetailRootProps {
    const periodLabel = formatter.format('daterange', item.report.period, {
        notation: 'long',
    });
    const comparisonPeriod = periodToRange(
        {
            start: item.report.period.from,
            end: item.report.period.to,
        },
        item.report.comparison
    );
    const comparisonLabel = formatter.format(
        'daterange',
        {
            from: comparisonPeriod.start,
            to: comparisonPeriod.end,
        },
        {
            notation: 'long',
        }
    );
    return {
        title: {
            label: getReportName(item),
        },
        date: {
            label: periodLabel,
            description: `This report is based on data for the period ${periodLabel}`,
        },
        comparison: {
            label: `Previous period`,
            description: `${comparisonLabel}`,
        },
    };
}
